/** Extract GIS OAuth access_token from redirect return URL (hash or query). */
export function parseOAuthReturnToken(): string | null {
  if (typeof window === 'undefined') return null;

  const hashBody = window.location.hash.replace(/^#/, '');
  if (hashBody.includes('access_token=')) {
    const token = new URLSearchParams(hashBody).get('access_token');
    if (token) return token;
  }

  const search = new URLSearchParams(window.location.search);
  const fromQuery = search.get('access_token');
  if (fromQuery) return fromQuery;

  const m = window.location.href.match(/[#?&]access_token=([^&]+)/);
  if (m?.[1]) {
    try {
      return decodeURIComponent(m[1]);
    } catch {
      return m[1];
    }
  }

  return null;
}

export function hasOAuthReturnInUrl(): boolean {
  if (typeof window === 'undefined') return false;
  const h = window.location.hash;
  const s = window.location.search;
  return (
    h.includes('access_token=') ||
    h.includes('error=') ||
    s.includes('access_token=') ||
    s.includes('error=')
  );
}
